import React from 'react';
import { CartProvider } from './../Providers/CartProvider';
import { AppStore } from './../Core/AppStore';
import { Storage } from './../Core/Storage';


export default class AddToCart extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			count: this.props.product.quantitytoadd || 1
		};
	}

	handleSubmit = (e) => {
		e.preventDefault();
        e.stopPropagation();
		const T = window.Texts.cart;
		let product = this.props.product;
		let count = this.state.count;
		if (count % product.quantitytoadd) {
			let newCount = Math.ceil(count / product.quantitytoadd) * product.quantitytoadd;
			const msg = T.quantityToAddWarning.replace("{name}", product.name)
				.replace("{quantitytoadd}", product.quantitytoadd)
				.replace("{newcount}", newCount);
			if (confirm(msg)) {
				count = newCount;
				this.setState({ count: newCount });
			} else {
				return;
			}
		}
		CartProvider.addItem(product, count, () => {
			if (this.props.product.list) {
				var item = this.findProductInList(this.props.product.list, this.props.product.code);
				if (item) {
					window.gtm.onAddProductToCart(item, count);
				}
			}
			AppStore.emit('Cart.AddingProduct', product);
		}, true);
		return true;
	}

	findProductInList(listName, code) {
		if (listName == 'detail')
			return  window.gtm.detail;
		else {
			var list = window.gtm.plist[listName];
			if (list) {
				var item = list.find(o => { return o.id === code; });
				if (item) {
					return item;
				}
			}
		}
	}


	handleChangeCount = (e) => {
		e.preventDefault();
		let newCount = parseInt(e.target.value);
		if (!isNaN(newCount) && newCount > 0) {
			this.setState({ count: newCount });
		}
	}


	render() {


		window.addHC = () => {
			alert(66);
		};

		var T = window.Texts.catalogue;
		if (this.props.mode == "detail") {
			return (
				<>
					<a className="btn" htref="#" onClick={(e) => this.handleSubmit(e)}>
						<input step={this.props.product.quantitytoadd} type="number" className="form-control" value={this.state.count} onClick={(e) => { e.stopPropagation(); }} onChange={(e) => this.handleChangeCount(e)} />
						<span>{Storage.instance().isSegmentUser() ? T.toCart : T.buy}</span>
					</a>
				</>
			);
		}
		else {
			return (
				<a className="btn buy-btn" htref="#" onClick={(e) => this.handleSubmit(e)} />
			)
		}
	}
}

//inicializace 
var elements = document.getElementsByClassName("app-addToCartForm");

for (var idx = elements.length - 1; idx >= 0; idx--) {
	var productid = elements[idx].getAttribute('data-id');
	var productcode = elements[idx].getAttribute('data-code');
	var productname = elements[idx].getAttribute('data-name');
	var productpicture = elements[idx].getAttribute('data-picture');
	var productprice = elements[idx].getAttribute('data-price');
	var producturl = elements[idx].getAttribute('data-url');
	var productquantitytoadd = elements[idx].getAttribute('data-quantity-to-add');
	var mode = elements[idx].getAttribute('data-mode');
	var list = elements[idx].getAttribute('data-list');
	var list = elements[idx].getAttribute('data-list');

	

	var product = {
		id: productid,
		code: productcode,
		name: productname,
		picture: productpicture,
		price: productprice,
		quantitytoadd: productquantitytoadd,
		url: producturl,
		list: list
	};
	// temporary render target
	var temp = document.createElement("div");
	// render


	ReactDOM.render(<AddToCart product={product} mode={mode} />, temp);
	// grab the container
	var container = elements[idx].parentNode;
	// and replace the child
	container.replaceChild(temp.childNodes[0], elements[idx]);
}

